import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './SliderNavigation.scss';

const SliderNavigation = ({ onPrevClick, onNextClick, canPrev = true, canNext = true }) => {
  return (
    <>
      <button
        className={`slider-arrow left ${!canPrev ? 'disabled' : ''}`}
        onClick={onPrevClick}
        disabled={!canPrev}
        aria-label="Previous slide"
      >
        <FaChevronLeft />
      </button>

      <button
        className={`slider-arrow right ${!canNext ? 'disabled' : ''}`}
        onClick={onNextClick}
        disabled={!canNext}
        aria-label="Next slide"
      >
        <FaChevronRight />
      </button>
    </>
  );
};

export default SliderNavigation;
